/** BoxMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('boxmesh', ['BoxMesh']);
//# sourceMappingURL=index.js.map